import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { Normalize } from 'styled-normalize';
import Bar from '../components/Bar/Bar';
import FAQ from '../components/FAQ/FAQ';
import Footer from '../components/Footer/Footer';
import Hero from '../components/Hero/Hero';
import Btn from '../components/Basic/Btn';
import Logos from '../components/Logos/Logos';
import PPP from '../components/PPP/PPP';
import Pricing from '../components/Pricing/Pricing';
import SEO from '../components/SEO/SEO';
import Testimonials from '../components/Testimonials/Testimonials';
import TOC from '../components/TOC/TOC';
import Who from '../components/Who/Who';
import GlobalStyle from '../utils/GlobalStyle';
import IpData from '../utils/ipData';
import theme from '../utils/theme';

const Wrap = styled.div``;

const HomePage = () => (
	<ThemeProvider theme={theme}>
		<SEO />
		<Normalize />
		<GlobalStyle />
		<Wrap>
			<PPP />
			<Bar />
			{/* <Notify /> */}
			<Hero login />
			<Logos />
			<Who />
			<Pricing id="signup" />
			<PPP noLink />
			<Testimonials cap="6" />
			<TOC />
			<Btn href="#signup">Start Learning VSCode ↑</Btn>
			<FAQ />
			<Testimonials />
			<Btn href="#signup">Make me a Pro Developer ↑</Btn>
			<Footer />
			<IpData />
		</Wrap>
	</ThemeProvider>
);

export default HomePage;
